import Vue from 'vue'
// Vue.config.devtools = true
import Router from 'vue-router'
import store from '../store/index'
import user from '../store/modules/user'
import * as types from '../store/mutation-types'
import NO_AUTH_ROUTES from './no_auth_routes'

// Our Page Components
const Signup = () => import('@/pages/Signup')
const Login = () => import('@/pages/Login')
const Manage = () => import('@/pages/Manage')
const Account = () => import('@/pages/Account')
const Server = () => import('@/pages/Server')
const SSLCerts = () => import('@/pages/Server/SSLCerts')
const DomainRedirects = () => import('@/pages/Server/DomainRedirects')
const Services = () => import('@/pages/Services')
const Billing = () => import('@/pages/Billing')
const PaymentMethods = () => import('@/pages/PaymentMethods')
const Invoice = () => import('@/pages/Invoice')
const UsernameRecovery = () => import('@/pages/UsernameRecovery')
const PasswordUpdate = () => import('@/pages/PasswordUpdate')
const Status404 = () => import('@/pages/Status404')


const PasswordGeneratorPage = () => import('@/pages/PasswordGeneratorPage')

const Test = () => import('@/pages/Test')

Vue.use(Router)

// Route table
const routes = [
  // Publicly accessible
  { path: '/', redirect: { name: 'login' } },
  { path: '/signup/:components?', name: 'signup', component: Signup },
  { path: '/login/', name: 'login', component: Login },
  { path: '/pw/', redirect: {name: 'password-recovery'}},
  { path: '/username-recovery/', name: 'username-recovery', component: UsernameRecovery },
  { path: '/password-update/:id', name: 'password-update', component: PasswordUpdate },
  { path: '/password-generator/', alias: '/passgen/', name: 'password-generator', component: PasswordGeneratorPage },
  // Account tab
  { path: '/account/', name: 'account', component: Account },
  // Admin tab

  // Services tab
  { path: '/services/', name: 'services', component: Services, meta: {perms: {services: 'view'}} },
  { path: '/services/:service', name: 'servicesParam', component: Services, meta: {perms: {services: 'view'}} },
  { path: '/servers/:server/manage', name: 'manage-server', component: Manage },
  { path: '/server/:iid', name: 'server', component: Server, meta: {perms: {services: 'view'}} },
  { path: '/server/:iid/ssl', name: 'ssl', component: SSLCerts, meta: {perms: {services: 'view'}} },
  { path: '/server/:iid/domain_redirects', name: 'domain_redirects', component: DomainRedirects, meta: {perms: {services: 'view'}} },
  // Billing tab
  { path: '/billing/', name: 'billing', component: Billing, meta: {perms: {payments: 'view'}} },
  { path: '/payment-methods/', name: 'payment-methods', component: PaymentMethods, meta: {perms: {payments: 'manage'}} },
  { path: '/invoice/:endpoint/:id', name: 'invoice', component: Invoice },
  // 404 Page
  { path: '*', name: '404', component: Status404 },
  { path: '/test/:argument', name: 'test', component: Test}
]

const router = new Router({
  mode: 'history',
  base: '/control/',
  routes
})

// If not authenticated, redirect away from routes that require authentication
const routeHelpers = {
  routeAuthCheck (to, from) {
    return new Promise((resolve, reject) => {
      store.dispatch('getProfile').then((result) => {
        if (store.state.user.loggedIn) {
          // Check user permissions for this page
          if ('meta' in to && 'perms' in to.meta && Object.keys(to.meta.perms).length > 0) {
            if (user.helpers.hasOnePermission(store.state.user.perms, to.meta.perms)) {
              resolve('')
            } else {
              // Failed authentication so redirect to home
              store.commit(types.ADD_NOTIFICATION, {
                type: 'danger',
                message: 'You do not have permission to view this'
              })
              resolve('account')
            }
          } else {
            resolve('')
          }
        } else {
          resolve('login')
        }
      }, errorResult => {
        // Could not get profile so most likely not logged in
        resolve('login')
      })
    })
  }
}

router.beforeEach((to, from, next) => {
  // Don't check auth or refresh token for theses pages
  if ('name' in to){
    sessionStorage.setItem('attemptingRoute', to.name)
  }
  if ('name' in to && NO_AUTH_ROUTES.includes(to.name)) {
    next()
    return
  } else {
    routeHelpers.routeAuthCheck(to, from).then(response => {
      if (response === '') {
        next()
      } else {
        next({ name: response })
      }
    })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js